import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const metrics = [{
  value: '50+',
  label: 'Years Experience'
}, {
  value: '100+',
  label: 'Framework Implementations'
}, {
  value: '3X',
  label: 'ROI Guarantee'
}, {
  value: '6',
  label: 'Core Growth Areas'
}];
const results = [{
  company: 'Tranzonic',
  metric1: '50%',
  metric1Label: 'Drop in onboarding time',
  metric2: '>90%',
  metric2Label: 'User adoption rate'
}, {
  company: 'M&M Transport',
  metric1: '100%',
  metric1Label: 'Modernized tech backbone',
  metric2: 'Zero',
  metric2Label: 'Downtime during delivery'
}, {
  company: 'Pacific Tank Lines',
  metric1: '65%',
  metric1Label: 'Database reduction',
  metric2: '40%',
  metric2Label: 'Performance improvement',
  metric3: '30%',
  metric3Label: 'Infrastructure cost drop'
}, {
  company: 'Foodliner & McCoy Transport',
  metric1: '60%',
  metric1Label: 'Faster claims resolution',
  metric2: '40%',
  metric2Label: 'Drop in submission errors'
}, {
  company: 'Liquid Transport',
  metric1: '66%',
  metric1Label: 'Reduction in audit cycles',
  metric2: '<3%',
  metric2Label: 'Invoice rework (down from 15%)',
  metric3: '$2M+',
  metric3Label: 'Annual savings'
}, {
  company: 'JLE Transport',
  metric1: '25%',
  metric1Label: 'Forecast accuracy improvement',
  metric2: '15%',
  metric2Label: 'Net profit increase in year one'
}];
export function Results() {
  return <section id="results" className="bg-white" data-id="element-319">
      {/* Metric Strip */}
      <div className="bg-navy border-y border-white/10 py-12 relative z-20" data-id="element-320">
        <div className="container-custom" data-id="element-321">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10" data-id="element-322">
            {metrics.map((m, i) => <div key={i} className="text-center px-4" data-id="element-323">
                <div className="text-3xl md:text-5xl font-black font-heading text-amber mb-2 tracking-tight" data-id="element-324">
                  {m.value}
                </div>
                <div className="text-xs md:text-sm font-bold uppercase tracking-wider text-white/70" data-id="element-325">
                  {m.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>

      <div className="section-padding" data-id="element-326">
        <div className="container-custom" data-id="element-327">
          <div className="max-w-4xl mb-16" data-id="element-328">
            <span className="eyebrow" data-id="element-329">Proof From Real Transportation Work</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-navy mb-6" data-id="element-330">
              Different Fleets. Different Bottlenecks. One Pattern: Better
              Systems Create Better Growth.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-331">
            {results.map((result, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-off-white border border-steel p-8 rounded-sm shadow-sm hover:shadow-md hover:border-navy/30 transition-all flex flex-col relative overflow-hidden group" data-id="element-332">
                <div className="absolute top-0 left-0 w-1 h-full bg-steel group-hover:bg-amber transition-colors" data-id="element-333"></div>
                <h3 className="text-xl font-bold font-heading text-navy mb-6 pb-4 border-b border-steel/50 pl-2" data-id="element-334">
                  {result.company}
                </h3>

                <div className="space-y-6 flex-grow pl-2" data-id="element-335">
                  <div data-id="element-336">
                    <div className="text-4xl md:text-5xl font-black font-heading text-navy mb-1 tracking-tighter" data-id="element-337">
                      {result.metric1}
                    </div>
                    <div className="text-sm font-bold text-body/70 uppercase tracking-wider" data-id="element-338">
                      {result.metric1Label}
                    </div>
                  </div>

                  <div data-id="element-339">
                    <div className="text-4xl md:text-5xl font-black font-heading text-navy mb-1 tracking-tighter" data-id="element-340">
                      {result.metric2}
                    </div>
                    <div className="text-sm font-bold text-body/70 uppercase tracking-wider" data-id="element-341">
                      {result.metric2Label}
                    </div>
                  </div>

                  {result.metric3 && <div data-id="element-342">
                      <div className="text-4xl md:text-5xl font-black font-heading text-navy mb-1 tracking-tighter" data-id="element-343">
                        {result.metric3}
                      </div>
                      <div className="text-sm font-bold text-body/70 uppercase tracking-wider" data-id="element-344">
                        {result.metric3Label}
                      </div>
                    </div>}
                </div>
              </motion.div>)}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between border-t border-steel pt-8" data-id="element-345">
            <p className="text-xs text-body/50 uppercase tracking-wider font-bold mb-6 sm:mb-0" data-id="element-346">
              * Results vary by company, execution, and engagement scope.
            </p>
            <a href="#contact" className="btn-primary group" data-id="element-347">
              See What FleetScale Could Fix First
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-348" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}